import React from "react";
import { hasPermission } from "../auth/Auth";
import { translate } from "./Translation";

export default class DeleteButton extends React.Component {

    onClick(evt) {
        //eslint-disable-next-line
        if (!confirm(translate("Ste si istý?"))) {
            return;
        }
        this.props.onClick();
    }

    render() {

        if (this.props.permission === true) {

        } else if (this.props.permission === false) {
            return <div />
        } else {
            if (typeof this.props.permission !== "boolean" && !hasPermission(this.props.permission)) {
                return <div />;
            }
        }

        return (
            <button className="btn btn-danger btn-xs" onClick={this.onClick.bind(this)}>
                <i className="fa fa-trash" />
            </button>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/base/DeleteButton.js